import { AuthorizeHttpClientDecorator } from "@/main/decorators";
import { makeAxiosHttpClient } from "@/main/factories/http-client";
import { getCachedAuthClientInstance } from "@/main/singleton/cached-auth-client-instance";
export var makeAuthorizeHttpClientDecorator = function () {
    return new AuthorizeHttpClientDecorator(makeAxiosHttpClient(), getCachedAuthClientInstance());
};
